var React = require('react');

function LocationInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 .52a5.39 5.39 0 0 0-5.59 5.15c0 5 3.88 8.61 5.17 9.66a.66.66 0 0 0 .84 0c1.29-1.05 5.17-4.63 5.17-9.66A5.39 5.39 0 0 0 8 .52zM8 14a15.2 15.2 0 0 1-2.46-2.76 9.85 9.85 0 0 1-1.88-5.57A4.14 4.14 0 0 1 8 1.77a4.14 4.14 0 0 1 4.34 3.9c0 4.08-2.96 7.16-4.34 8.33z","key":0}),React.createElement("path",{"d":"M8 2.54a2.73 2.73 0 0 0-2.84 2.65A2.74 2.74 0 0 0 8 7.84a2.75 2.75 0 0 0 2.83-2.65A2.74 2.74 0 0 0 8 2.54zm0 4.05a1.49 1.49 0 0 1-1.57-1.4A1.49 1.49 0 0 1 8 3.79a1.5 1.5 0 0 1 1.58 1.4A1.5 1.5 0 0 1 8 6.59z","key":1})]);
}

LocationInline.defaultProps = {"fill":"#000000","width":"40px","height":"40px","viewBox":"0 0 16 16"};

module.exports = LocationInline;

LocationInline.default = LocationInline;
